import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const getTopSellers = ({ filters = '' }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const { startDate } = store.getters.dates;
    const { endDate } = store.getters.dates;
    let segmentId;
    if (filters.includes('storeId'))
        segmentId = 1;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: 'seller/ranking/getTopSellers',
        params: {
            brand: brand.id,
            startDate,
            endDate,
            segment: segmentId,
            ...(filters && { filter: filters }),
        },
    });
};
export const getTopSellersDetails = ({ storeId, orderBy, limit, page, fileType, term, responseType, }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const { startDate } = store.getters.dates;
    const { endDate } = store.getters.dates;
    let segmentId;
    if (storeId.includes('storeId'))
        segmentId = 1;
    return axios.get('/seller/ranking/getTable', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            startDate,
            endDate,
            segment: segmentId,
            filter: storeId,
            orderBy,
            limit,
            page,
            term,
            export: fileType,
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        responseType,
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getTopCustomersDetails = ({ storeId, orderBy, limit, page, fileType, term, responseType, }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const { startDate } = store.getters.dates;
    const { endDate } = store.getters.dates;
    let segmentId;
    if (storeId.includes('storeId'))
        segmentId = 1;
    return axios.get('/customer/ranking/getTable', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            startDate,
            endDate,
            segment: segmentId,
            filter: storeId,
            orderBy,
            limit,
            page,
            term,
            export: fileType,
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        responseType,
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getTopCustomers = ({ filters = '' }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const { startDate } = store.getters.dates;
    const { endDate } = store.getters.dates;
    let segmentId;
    if (filters.includes('storeId'))
        segmentId = 1;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: 'customer/ranking/getTopCustomers',
        params: {
            brand: brand.id,
            startDate,
            endDate,
            segment: segmentId,
            ...(filters && { filter: filters }),
        },
    });
};
